import { LayoutContext, ScreenSize } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { BillPaymentLandingNativeComponent } from './BillPaymentLandingNative.component';
import { BillPaymentLandingWebComponent } from './BillPaymentLandingWeb.component';

export interface BillPaymentLandingProps {}
export const BillPaymentLandingScreen: React.FC<BillPaymentLandingProps> = () => {
  const layout = useContext(LayoutContext);
  const isTablet = layout.screenSize === ScreenSize.Tablet;

  if (layout.isMobile || isTablet) {
    return <BillPaymentLandingNativeComponent />;
  }
  return <BillPaymentLandingWebComponent />;
};
